import React, { Component } from 'react'
import { connect } from 'react-redux'
import { path } from 'ramda'
import {
  Menu, Image, Icon, Responsive, Dropdown, Button
} from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import AuthActions from 'Redux/AuthRedux'
import SelectionActions from 'Redux/SelectionRedux'
import Avatar from 'Components/Avatar'
import logo from 'Images/logo.png'
import TrialMessage from './TrialMessage'
import styles from './NavBarStyles'

class NavBar extends Component {

  toggleSideBar = (key) => () => {
    this.props.selectionsToggleSidebar(key)
  }

  decideBehaviour = () => {
    if (!this.props.match.url.includes('projects') ||
        window.screen.width > 992) {
      return {
        as: Link,
        to: this.props.activeProject.id
            ? `/projects/${this.props.activeProject.id}`
            : '/projects'
      }
    }
    return { onClick: this.toggleSideBar('left') }
  }

  render () {
    const projectId = path(['params', 'projectId'], this.props.match)
    const trigger = (
      <Avatar
        name={this.props.userData.name}
        radius={30}
      />
    )
    // Team id is hardcoded for subscription button. Need better UX for this
    return (
      <Menu size='large' style={{marginBottom: 0}}>
        <Menu.Item {... this.decideBehaviour()} name='home'>
            <div className={styles.logo}>
              <Image src={logo} alt='logo' width='30px' className={styles.logoImg}/>
            </div>
        </Menu.Item>

        <Menu.Menu position='right'>
          <Menu.Item >
            <TrialMessage />
          </Menu.Item>
          <Menu.Item
            name='subscribe'
            as={Link}
            to={`/teams/${this.props.teams[0] ? this.props.teams[0].id : null}/subscription`}>
            <Button
              basic
              primary
              positive
              >
                Subscribe
            </Button>
          </Menu.Item>
          <Menu.Item
            name='changeLog'>
            <Icon name='alarm' className='beamerTrigger' />
          </Menu.Item>
          <Menu.Item
            name='activities'
            as={Link}
            to='/activities'>
            <Icon name='clock outline' />
          </Menu.Item>
          <Menu.Item
            name='teams'
            as={Link}
            to='/teams'>
              <Icon name='users' />
          </Menu.Item>
          <Dropdown trigger={trigger} item simple attached='top right'>
            <Dropdown.Menu className={styles.settingsMenu}>
              <Dropdown.Item
                as={Link} to='/settings'
                text='Settings'
                icon='settings' />
              <Dropdown.Item
                onClick={this.props.logoutRequest}
                text='Logout'
                icon='sign out' />
            </Dropdown.Menu>
          </Dropdown>
        </Menu.Menu>
        {projectId &&
          <Responsive
            minWidth={320}
            maxWidth={991}
            as={Menu.Item}
            onClick={this.toggleSideBar('right')}>
              <Icon name='paper plane outline' />
          </Responsive>
        }
      </Menu>
    )
  }
}

const mapStateToProps = (state) => ({
  userData: state.auth.userData,
  activeProject: state.selections.activeProject,
  teams: state.teams.listData,
})

const mapDispatchToProps = (dispatch) => ({
  logoutRequest: () => dispatch(AuthActions.logoutRequest()),
  selectionsToggleSidebar: (key) =>
    dispatch(SelectionActions.selectionsToggleSidebar(key))
})

export default connect(mapStateToProps, mapDispatchToProps)(NavBar)



// WEBPACK FOOTER //
// ./src/Components/NavBar.js